import React, { Component, RefObject } from "react";
import { CloseButton } from "../../components/CloseButton";
import { KonvaImageEditor } from "../../../modules/KonvaImageEditor";
import { App } from "../../../App";
import { AppScreen } from "../../../AppScreen";
import pressHoldImageSrc from "../../../assets/images/press-hold-image.svg";

export interface CameraModeProps
{
    characterImage: string;
    onClose: () => void;
    onEdit: () => void;
}

interface CameraModeState
{
    screen: Screen;
    imagePreview: string;
}

enum Screen 
{
    FreeMode,
    TakenPhoto,
}

export class CameraMode extends Component<CameraModeProps, CameraModeState>
{
    private imageEditor: KonvaImageEditor;
    private containerRef: React.RefObject<HTMLDivElement>;

    constructor(props: CameraModeProps)
    {
        super(props);

        this.containerRef = React.createRef();

        this.state = {
            screen: Screen.FreeMode,
            imagePreview: null
        };
    }

    public componentDidMount(): void
    {
        document.body.classList.add("camera-mode");

        const container = this.containerRef.current;

        this.imageEditor = new KonvaImageEditor(container, this.props.characterImage);
        this.imageEditor.start();
    }

    private onTakePhotoClicked(): void 
    {
        document.body.classList.add("photo-taken");

        let imagePreview: string = this.imageEditor.getImage();

        this.imageEditor.pause();
        this.setState({
            screen: Screen.TakenPhoto,
            imagePreview: imagePreview
        });
    }

    private onSavePhoto(): void 
    {
        this.imageEditor.savePhotoToDisk();
        this.imageEditor.pause();
    }

    private onResume(): void
    {
        document.body.classList.remove("photo-taken");

        this.imageEditor.play();
        this.setState({
            screen: Screen.FreeMode
        });
    }

    public render()
    {
        return (
            <>
                <CloseButton onClicked={this.props.onClose.bind(this)} />

                <div id="container" ref={this.containerRef} style={this.state.screen === Screen.TakenPhoto ? {
                    "opacity": 0,
                    "width": 0,
                    "height": 0
                } : {}}>
                </div>

                {this.state.screen === Screen.FreeMode ?
                    <>
                        <div className="btn-container btn-container-fixed">
                            <button className="btn btn-primary" title="Edit character" onClick={this.props.onEdit.bind(this)}>
                                Edit Character
                            </button>

                            <button className="btn btn-primary" onClick={this.onTakePhotoClicked.bind(this)} title="Take photo">
                                Take Photo
                            </button>
                        </div>
                    </>
                    : null
                }

                {this.state.screen === Screen.TakenPhoto ?
                    <div className="preview-photo">
                        <div className="container">

                            <div className="image-preview-container">
                                <div className="image-preview">
                                    <img src={this.state.imagePreview} />
                                </div>
                            </div>

                            <div className="mt-2 mb-2 press-hold">
                                <img src={pressHoldImageSrc} alt="Press & Hold Image To Save" />
                            </div>

                            <div className="mb-2 mt-2 ms-auto me-auto">
                                <button className="btn btn-primary" onClick={this.onResume.bind(this)} title="Take again?">
                                    Take again?
                                </button>
                            </div>

                            <div className="d-flex ms-auto me-auto mb-2 mt-auto">
                                <button className="btn btn-text" onClick={() => App.I.changeScreen(AppScreen.GamesActivities)} style={{ zIndex: 1 }}>
                                    More games and activities
                                    <i className="bi bi-chevron-right ps-1"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    : null
                }

            </>
        );
    }

    public componentWillUnmount(): void
    {
        document.body.classList.remove("camera-mode");
        this.imageEditor.stop();
    }
}
